module.exports = __webpack_public_path__ + "img/MEDIA071.93ec7593.jpg";